export default __webpack_public_path__ + "static/media/slide21.455fbfea.jpg";